import {Component, OnInit} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs-compat/operator/switchMap';

@Component({
    selector: 'app-product-category',
    templateUrl: './product-category.component.html',
    styleUrls: ['./product-category.component.css']
})
export class ProductCategoryComponent implements OnInit {
    constructor(private route: ActivatedRoute) { }
    productTypeName : string = '';
    ngOnInit() {
        this.productTypeName = this.route.snapshot.paramMap.get('name');
    }

}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/product-category/product-category.component.ts